<template>
  <div style="display: inline-block; min-width: 100%; text-align: center">
    <p style="font-size: 120%">推薦・紹介文の作成をお願いしよう！</p>
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <p style="font-size: 100%; text-align: left">
        あなたの名前：<br />{{ store.username }}
      </p>
      <p style="font-size: 100%; text-align: left">
        あなたのメールアドレス：<br />{{ store.email }}
      </p>
    </div>
    <br />
    <div style="padding: 20px 0; font-size: 70%; color: red">
      ※推薦・紹介文が作成されたら、上記のメールアドレスにお知らせいたします。
    </div>
    <br />
    <p style="font-size: 120%">お願いする相手の情報：</p>
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <p style="font-size: 100%; text-align: left">
        姓名：<br />
        <el-input
          class="input-md"
          placeholder=""
          title="姓名"
          v-model="store.introName"
          type="email"
        />
      </p>
    </div>
    <br />
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <p style="font-size: 100%; text-align: left">
        メールアドレス：<br />
        <el-input
          class="input-md"
          placeholder=""
          title="メールアドレス"
          v-model="store.introEmail"
          type="email"
        />
      </p>
    </div>
    <br />
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <p style="font-size: 100%; text-align: left">
        関係：<br />
        <el-select v-model="store.relationship" placeholder="選択してください">
          <el-option
            v-for="item in store.relationshipOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <br />
        <el-input
          class="input-md"
          v-if="store.isRelationshipEtc"
          placeholder=""
          title=""
          v-model="store.relationshipEtc"
          type="email"
        />
      </p>
    </div>
    <br />
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <p style="font-size: 100%; text-align: left">
        <span>作成期限は依頼してから２週間後になります。</span>
        <el-date-picker
          v-if="false"
          v-model="store.limitDate"
          type="date"
          :clearable="false"
          placeholder="選択してください"
          :format="'yyyy年M月d日'"
        />
      </p>
    </div>
    <br />
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <br />
      <p style="font-size: 100%; text-align: left">
        お願い内容：
        <el-button @click="store.setSampleVisible(true)" type="success"
          >例文から追加</el-button
        >
        <br />
        <br />
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 15 }"
          v-model="store.requestStatement"
        />
      </p>
    </div>
    <div class="text-center">
      <br />
      <el-button
        id="send-introduction"
        type="success"
        v-if="!store.isSended"
        style="background-color: #e3165c; border-color: #e3165c; color: #fff"
        @click="$emit('submit')"
        >お願いを送信する</el-button
      >
      <el-button
        id="send-adtop-pdf"
        type="success"
        v-if="store.isSended"
        style="background-color: #0f9934; border-color: #0f9934"
        @click="store.close()"
        >送信しました</el-button
      >
    </div>
    <br />
  </div>
</template>

<script setup lang="ts">
import { useIntroductionDialogStore } from '@/stores/introductionDialog'

defineEmits<{ (e: 'submit'): void }>()

const store = useIntroductionDialogStore()
</script>
